$(function () {
    $('[js-filter-icon]').on('click', function (e) {
        e.preventDefault();
        $('[js-filter]').stop().slideToggle();
    });
    $('[js-filter-slide]').on('click', function (e) {
        e.preventDefault();
        $('[js-filter]').stop().slideToggle();
    })
});